/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useState, useCallback, useEffect, useRef} from 'react'
import moment from 'moment';
import { Calendar } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { removeLastComma } from '../../redux/helper/RemoveLastComma';
import { createUrl } from '../../redux/helper/CreateQuery';
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";


const Filters = ({setfilterOpen, filterOpen, Filter, setFilter, filterUrl, setFilterUrl, handleFetchInvoices, dateselected, setdateselected }) => {
    const toggleState = {
        start_date: false,
        end_date: false,
        order_start_date: false,
        order_end_date: false,
    };
    const [selected, setselected] = useState('TRX_DATE');
    const [toggle, settoggle] = useState(toggleState);
    const ref = useRef();
    const dateRef = useRef();

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const getObjectUrl=()=>{
        let final='';
        Filter['order_status'].length>0 && Filter['order_status'].map((val)=>{
            final+=`${val},`
        })
        return removeLastComma(final);       
    }

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'CATEGORY':
                if (Filter[key].length !== 0) {
                    final += `&CATEGORY=${createUrl(Filter[key])}`;
                }
                break;
            case 'PAYMENT_STATUS':
                if (Filter[key].length !== 0) {
                    final += `&PAYMENT_STATUS=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (dateselected.start_date !== '' && dateselected.end_date !== '') {
            final += `&TRX_DATE=${moment(dateselected.start_date).format('DD-MM-YYYY')},${moment(dateselected.end_date).format('DD-MM-YYYY')}`;
        }
        if (dateselected.order_start_date !== '' && dateselected.order_end_date !== '') {
            final += `&ORDER_ACCEPTANCE_DATE=${moment(dateselected.order_start_date).format('DD-MM-YYYY')},${moment(dateselected.order_end_date).format('DD-MM-YYYY')}`;
        }

        setFilterUrl(final)
        handleFetchInvoices(final)
        return final;
    };

    const handleClear = ()=>{
        setFilter({
            TRX_DATE:[],
            CATEGORY:[],
            ORDER_ACCEPTANCE_DATE:[],
            PAYMENT_STATUS:[],
        })
        setdateselected({
            start_date: '',
            end_date: '',
            order_start_date:'',
            order_end_date: '',
        });
        setFilterUrl('')
        handleFetchInvoices('')     
    }

    const HandleFilter=useCallback((key,val)=>{
        const Filtercopy={...Filter};
        const idx=Filtercopy[key].indexOf(val);
        if(idx=== -1){
            Filtercopy[key].push(val)
        }else{
            Filtercopy[key].splice(idx,1)
        }
        Filtercopy[key]
        setFilter(Filtercopy)
        return idx>-1
        // return false
    
    },[])

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setdateselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state)
        setdateselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };

    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (!ref.current.contains(event.target)) {
    //             setTimeout(() => {
    //                 settoggle((prevState) => ({
    //                     ...prevState,
    //                     start_date: false,
    //                     end_date: false,
    //                 }));
    //             }, 1000);
    //         }
    //     };
    //     document.addEventListener('mousedown', handleClickOutside);
    // }, [ref]);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                    order_start_date: false,
                    order_end_date:false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

  
    return (
        <>
            <div className={`modal fade fixed top-0 left-0 ${filterOpen ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[575px] mx-auto px-2.5" style={{ margin: 'auto'}}>
                    <div
                        className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                        <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                            <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                                Filter
                            </h5>
                            <button onClick={() => setfilterOpen(false)} type="button">                                  
                                <img src="images/cross-mark.svg" alt="icon" className="absolute top-3 right-2.5 cursor-pointer w-4 h-4"/>
                            </button>
                        </div>
                        <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                            <div className="flex items-start">
                                <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 sm:w-[33%] w-[40%] h-full" id="pills-tabVertical" role="tablist">
                                    <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselected('TRX_DATE')}>
                                        <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selected==='TRX_DATE'?'active':''} relative w-full`} id="pills-priceranje" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"
                                            aria-controls="pills-pricetab" aria-selected="true">Date  Range
                                        </a>
                                    </li>
                                    <li className="nav-item flex-grow text-start w-full my-4" role="presentation" onClick={() => setselected('ORDER_ACCEPTANCE_DATE')}>
                                        <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selected==='ORDER_ACCEPTANCE_DATE'?'active':''} relative w-full`} id="pills-size" data-bs-toggle="pill" data-bs-target="#pills-sizemm" role="tab"
                                            aria-controls="pills-sizemm" aria-selected="false" >Order Date Range
                                        </a>
                                    </li>
                                    <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselected('CATEGORY')}>
                                        <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selected==='CATEGORY'?'active':''} relative w-full`} id="pills-categories" data-bs-toggle="pill" data-bs-target="#pillcategorie" role="tab"
                                            aria-controls="pillcategorie" aria-selected="false">Order Category
                                        </a>
                                    </li>
                                    <li className="nav-item flex-grow text-start w-full mt-4" role="presentation" onClick={() => setselected('PAYMENT_STATUS')}>
                                        <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selected==='PAYMENT_STATUS'?'active':''} order relative w-full`} id="pills-status" data-bs-toggle="pill" data-bs-target="#pillstatus" role="tab"
                                            aria-controls="pillstatus" aria-selected="false">Payment Status
                                        </a>
                                    </li>
                                </ul>
                                <div ref={dateRef} className="tab-content sm:w-[67%] w-[60%] h-[300px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                    <div className={`tab-pane fade ${selected === 'TRX_DATE' ? 'show active' : ''} px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                        <div className="relative">
                                            <div className="flex sm:flex-row flex-col items-center mt-3 -mx-1">
                                                <div className="relative sm:w-1/2 w-full px-1 mb-2"
                                                    onClick={() => handleToggle('start_date')}
                                                >
                                                    <label></label>
                                                    <img 
                                                        onClick={() => handleToggle('start_date')}
                                                        src="images/Iconawesome-calendar-alt.svg" 
                                                        alt="icon" 
                                                        className="absolute top-3 right-2.5 cursor-pointer"/>
                                                    <input 
                                                        datepicker 
                                                        datepicker-autohide 
                                                        type="text" 
                                                        value={dateselected.start_date === '' ? '' : moment(dateselected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                            .join('/')}
                                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"  
                                                        placeholder="From Date" />
                                                </div>
                                                {toggle.start_date && (
                                                    <Calendar
                                                        value={moment(dateselected.start_date).format('YYYY/MM/DD').start_date}
                                                        onChange={(val) => handleDate(val, 'start_date')}
                                                        placeholder="Date From"
                                                    />
                                                )}
                                                <div className="relative sm:w-1/2 w-full px-1 mb-2"
                                                    onClick={() => handleToggle('end_date')}
                                                >
                                                    <label></label>
                                                    <img 
                                                        onClick={() => handleToggle('end_date')}
                                                        src="/images/Iconawesome-calendar-alt.svg" 
                                                        alt="icon" 
                                                        className="absolute top-3 right-2.5 cursor-pointer"/>
                                                    <input 
                                                        datepicker 
                                                        datepicker-autohide 
                                                        type="text" 
                                                        value={dateselected.end_date === '' ? '' : moment(dateselected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                            .join('/')}
                                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"  
                                                        placeholder="To Date" 
                                                    />
                                                </div>
                                                {toggle.end_date && (
                                                    <Calendar
                                                        value={moment(dateselected.end_date).format('YYYY/MM/DD').end_date}
                                                        onChange={(val) => handleDate(val, 'end_date')}
                                                        placeholder="Date to"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`tab-pane fade ${selected === 'ORDER_ACCEPTANCE_DATE' ? 'show active' : ''} w-full px-3`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size" ref={ref}>
                                        <div className="relative">
                                            <div className="flex sm:flex-row flex-col items-center mt-3 -mx-1">
                                                <div className="relative sm:w-1/2 w-full px-1 mb-2">
                                                    <label></label>
                                                    <img 
                                                        src="/images/Iconawesome-calendar-alt.svg" 
                                                        alt="icon" 
                                                        className="absolute top-3 right-2.5 cursor-pointer"
                                                        onClick={() => handleToggle('order_start_date')}
                                                    />
                                                    <input 
                                                        datepicker 
                                                        datepicker-autohide type="text" 
                                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"  
                                                        placeholder="From Date"
                                                        value={dateselected.order_start_date === '' ? '' : moment(dateselected.order_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                            .join('/')}
                                                        onClick={() => handleToggle('order_start_date')}
                                                    />
                                                </div>
                                                {toggle.order_start_date && (
                                                    <Calendar
                                                        value={moment(selected.order_start_date).format('YYYY/MM/DD').order_start_date}
                                                        onChange={(val) => handleDate(val, 'order_start_date')}
                                                        placeholder="Date from"
                                                    />
                                                )}
                                                <div className="relative sm:w-1/2 w-full px-1 mb-2">
                                                    <label></label>
                                                    <img 
                                                        src="images/Iconawesome-calendar-alt.svg" alt="icon" 
                                                        className="absolute top-3 right-2.5 cursor-pointer"
                                                        onClick={() => handleToggle('order_end_date')}
                                                    />
                                                    <input 
                                                        datepicker 
                                                        datepicker-autohide 
                                                        type="text" 
                                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"  
                                                        placeholder="To Date"
                                                        value={dateselected.order_end_date === '' ? '' : moment(dateselected.order_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                            .join('/')}
                                                        onClick={() => handleToggle('order_end_date')}
                                                    />
                                                </div>
                                                {toggle.order_end_date && (
                                                    <Calendar
                                                        value={moment(selected.order_end_date).format('YYYY/MM/DD').order_end_date}
                                                        onChange={(val) => handleDate(val, 'order_end_date')}
                                                        placeholder="Date to"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`tab-pane fade ${selected === 'CATEGORY' ? 'show active' : ''} px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories" ref={ref}>
                                        <div className="cursor-pointer">
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['CATEGORY']?.includes('Consumables') ? '#555259':''}`}} />
                                                    }
                                                    name="my-input"
                                                    id="mn1"
                                                    className="cursor-pointer"
                                                    checked={Filter['CATEGORY']?.includes('Consumables')}
                                                    onChange={()=>HandleFilter('CATEGORY','Consumables')}    
                                                    style={{ cursor: "pointer" }}
                                                    labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                                    borderColor={`${Filter['CATEGORY']?.includes('Consumables')?"#B8C5DC":"#555259"}`}

                                                />
                                                <label htmlFor="mn11" 
                                                    onClick={() => HandleFilter('CATEGORY', 'Consumables')}
                                                    className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Consumables</label>
                                            </div>
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['CATEGORY']?.includes('Equipments') ? '#555259':''}`}} />
                                                    }
                                                    name="my-input"
                                                    id="mn1"
                                                    className="cursor-pointer"
                                                    checked={Filter['CATEGORY']?.includes('Equipments')}
                                                    onChange={()=>HandleFilter('CATEGORY','Equipments')}    
                                                    borderColor={`${Filter['CATEGORY']?.includes('Equipments')?"#B8C5DC":"#555259"}`}
                                                    style={{ cursor: "pointer" }}
                                                    labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                                />
                                                <label htmlFor="mn12" 
                                                    onClick={() => HandleFilter('CATEGORY', 'Equipments')}
                                                    className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Equipments</label>
                                            </div>
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['CATEGORY']?.includes('Others') ? '#555259':''}`}} />
                                                    }
                                                    name="my-input"
                                                    id="mn1"
                                                    className="cursor-pointer"
                                                    checked={Filter['CATEGORY']?.includes('Others')}
                                                    onChange={()=>HandleFilter('CATEGORY','Others')}    
                                                    borderColor={`${Filter['CATEGORY']?.includes('Others')?"#B8C5DC":"#555259"}`}
                                                    style={{ cursor: "pointer" }}
                                                    labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                                />
                                                <label htmlFor="mm13" 
                                                    onClick={() => HandleFilter('CATEGORY', 'Others')}
                                                    className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Others</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`tab-pane fade ${selected === 'PAYMENT_STATUS' ? 'show active' : ''} px-3`} id="pillstatus" role="tabpanel" aria-labelledby="pills-status">
                                        <div className="cursor-pointer">
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['PAYMENT_STATUS']?.includes('PENDING') ? '#555259':''}`}} />
                                                    }
                                                    name="my-input"
                                                    id="mn1"
                                                    className="cursor-pointer"
                                                    checked={Filter['PAYMENT_STATUS']?.includes('PENDING')}
                                                    onChange={()=>HandleFilter('PAYMENT_STATUS','PENDING')}    
                                                    borderColor={`${Filter['PAYMENT_STATUS']?.includes('PENDING')?"#B8C5DC":"#555259"}`}
                                                    style={{ cursor: "pointer" }}
                                                    labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                                />
                                                <label htmlFor="mm1" 
                                                    onClick={()=>HandleFilter('PAYMENT_STATUS','PENDING')} 
                                                    className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Pending</label>
                                            </div>
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['PAYMENT_STATUS']?.includes('PARTIAL') ? '#555259':''}`}} />
                                                    }
                                                    name="my-input"
                                                    id="mn1"
                                                    className="cursor-pointer"
                                                    checked={Filter['PAYMENT_STATUS']?.includes('PARTIAL')}
                                                    onChange={()=>HandleFilter('PAYMENT_STATUS','PARTIAL')}    
                                                    borderColor={`${Filter['PAYMENT_STATUS']?.includes('PARTIAL')?"#B8C5DC":"#555259"}`}
                                                    style={{ cursor: "pointer" }}
                                                    labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                                />
                                                <label htmlFor="mm2" 
                                                    onClick={()=>HandleFilter('PAYMENT_STATUS','PARTIAL')} 
                                                    className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Partial</label>
                                            </div>
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['PAYMENT_STATUS']?.includes('PAID') ? '#555259':''}`}} />
                                                    }
                                                    name="my-input"
                                                    id="mn1"
                                                    className="cursor-pointer"
                                                    checked={Filter['PAYMENT_STATUS']?.includes('PAID')}
                                                    onChange={()=>HandleFilter('PAYMENT_STATUS','PAID')}    
                                                    borderColor={`${Filter['PAYMENT_STATUS']?.includes('PAID')?"#B8C5DC":"#555259"}`}
                                                    style={{ cursor: "pointer" }}
                                                    labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                                />
                                                <label htmlFor="mm3" 
                                                    onClick={()=>HandleFilter('PAYMENT_STATUS','PAID')} 
                                                    className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Paid</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                            <div className="flex w-full">
                                <div className="pt-3 flex justify-end w-[30%] mr-5">
                                    <button 
                                        type="button" 
                                        className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]" data-bs-dismiss="modal" aria-label="Close"
                                        onClick={() => handleClear()}
                                    >
                                        Clear Filter
                                    </button>
                                </div>
                                <div className="pt-3 flex justify-end w-[70%]">
                                    <button 
                                        type="button"
                                        onClick={() => generateUrl()} 
                                        className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                                        Apply Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
        </>
    )
}

export default Filters